import FormBase from "../FormBase";
import FormFieldBase from "../FormFieldBase";
import ValidationBase, { ValidationType } from "../ValidationBase";
import Professional from '../../models/Professional'
import VocationalTraningService from "../../services/VocationalTraningService";

export class VocationalTraningFormItem {
    Id: number;
    Expertise: string;
    ExpertiseValue: any;
    DateAcquisition: string;
    Title: string;
    TitleValue: any
    Institution: string;
    YearCompletion: string;
    OperationArea: string;
    OperationAreaValue: any;

    constructor(Id: number, Expertise: any, DateAcquisition: string, Title: any, Institution: string, OperationArea: any, YearCompletion: string) {
        this.Id = Id;
        this.Expertise = Expertise.Text;
        this.ExpertiseValue = Expertise;
        this.DateAcquisition = DateAcquisition;
        this.Title = Title.Text;
        this.TitleValue = Title;
        this.Institution = Institution;
        this.OperationArea = OperationArea.Text;
        this.OperationAreaValue = OperationArea;
        this.YearCompletion = YearCompletion;
    }

    static NewInstance(): VocationalTraningFormItem {
        return new VocationalTraningFormItem(0, "", "", "", "", "", "");
    }

}

export default class VocationalTraningForm implements FormBase {

    Expertise: FormFieldBase;
    DateAcquisition: FormFieldBase;
    Title: FormFieldBase;
    Institution: FormFieldBase;
    YearCompletion: FormFieldBase;
    OperationArea: FormFieldBase;
    VocationalTraningFormItemList: VocationalTraningFormItem[];
    VocationalTraningFormItemToEdit: VocationalTraningFormItem;

    constructor(Expertise: string, DateAcquisition: string, Title: string, Institution: string, OperationArea: string, YearCompletion: string) {

        this.Expertise = new FormFieldBase(Expertise, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
        this.DateAcquisition = new FormFieldBase(DateAcquisition, [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("A data de obtenção informada é inválida.", ValidationType.DATA)]);;
        this.Title = new FormFieldBase(Title, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
        this.Institution = new FormFieldBase(Institution, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
        this.YearCompletion = new FormFieldBase(YearCompletion, [new ValidationBase("", ValidationType.OBRIGATORIO)]);;
        this.OperationArea = new FormFieldBase(OperationArea, []);
        this.VocationalTraningFormItemList = new Array<VocationalTraningFormItem>();
        this.VocationalTraningFormItemToEdit = VocationalTraningFormItem.NewInstance();
    }

    AddOrUpdateVocationalTraningFormItem() {
        if (this.ValidateForm()) {

            if (this.VocationalTraningFormItemToEdit === null || this.VocationalTraningFormItemToEdit.Id === 0) {

                let vocationalTraningFormItem = new VocationalTraningFormItem(
                    this.getNewId(),
                    this.Expertise.Value,
                    this.DateAcquisition.Value,
                    this.Title.Value,
                    this.Institution.Value,
                    this.OperationArea.Value,
                    this.YearCompletion.Value
                )

                this.VocationalTraningFormItemList.push(vocationalTraningFormItem);
            } else {
                for (let index = 0; index < this.VocationalTraningFormItemList.length; index++) {
                    const element = this.VocationalTraningFormItemList[index];
                    if (element.Id === this.VocationalTraningFormItemToEdit.Id) {

                        let vocationalTraningFormItem = new VocationalTraningFormItem(
                            element.Id,
                            this.Expertise.Value,
                            this.DateAcquisition.Value,
                            this.Title.Value,
                            this.Institution.Value,
                            this.OperationArea.Value,
                            this.YearCompletion.Value
                        )

                        this.VocationalTraningFormItemList[index] = vocationalTraningFormItem;
                    }
                }
            }
            this.ResetForm();
        }
    }

    CallInsertOrUpdateApi(Professional: Professional): Promise<boolean> {
        const dataJson = this.getJsonObjet();
        return VocationalTraningService.postInsertOrUpdateVocationalTraning(dataJson, Professional.Id);
    }

    EditVocationalTraningFormItem(id: number) {
        this.ResetForm();

        for (let index = 0; index < this.VocationalTraningFormItemList.length; index++) {
            const element = this.VocationalTraningFormItemList[index];

            if (element.Id === id) {
                this.VocationalTraningFormItemToEdit = element;
                this.Expertise.Value = this.VocationalTraningFormItemToEdit.ExpertiseValue;
                this.DateAcquisition.Value = this.VocationalTraningFormItemToEdit.DateAcquisition;
                this.Title.Value = this.VocationalTraningFormItemToEdit.TitleValue;
                this.Institution.Value = this.VocationalTraningFormItemToEdit.Institution;
                this.OperationArea.Value = this.VocationalTraningFormItemToEdit.OperationAreaValue;
                this.YearCompletion.Value = this.VocationalTraningFormItemToEdit.YearCompletion;
            }
        }
    }

    RemoveVocationalTraningFormItem(id: number) {
        for (let index = 0; index < this.VocationalTraningFormItemList.length; index++) {
            const element = this.VocationalTraningFormItemList[index];
            if (element.Id === id) {
                this.VocationalTraningFormItemList.splice(index, 1);
            }
        }
    }


    static NewInstance(): VocationalTraningForm {
        return new VocationalTraningForm("", "", "", "", "", "");
    }

    ValidateForm(): boolean {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        return formIsValid;
    }


    ValidateToGoNextStep(): string {
        if (this.VocationalTraningFormItemList.length === 0) {
            return "Por favor, insira ao menos uma formação profissional."
        }
        return "";
    }

    ResetForm(): void {
        let propNames = Object.getOwnPropertyNames(this);
        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            this.GetFieldByName(element).Value = "";
            this.GetFieldByName(element).Error = "";
        }

        this.VocationalTraningFormItemToEdit = VocationalTraningFormItem.NewInstance();
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "Expertise":
                return this.Expertise;
            case "DateAcquisition":
                return this.DateAcquisition
            case "Title":
                return this.Title
            case "Institution":
                return this.Institution
            case "YearCompletion":
                return this.YearCompletion
            case "OperationArea":
                return this.OperationArea

            default:
                return new FormFieldBase("", []);
        }
    }


    getNewId(): number {
        if (this.VocationalTraningFormItemList.length > 0) {
            let maxId = Math.max.apply(Math, this.VocationalTraningFormItemList.map(function (o) { return o.Id; }))
            return maxId + 1;
        } else {
            return 1;
        }
    }


    getJsonObjet(professionalId: number = 0) {

        let viewModelList: any[] = [];

        if (this.VocationalTraningFormItemList !== null && this.VocationalTraningFormItemList.length > 0) {
            this.VocationalTraningFormItemList.forEach((element: VocationalTraningFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "expertiseId": element.ExpertiseValue.Id,
                    "specialtyTitleId": element.TitleValue.Id,
                    "operationAreaId": (element.OperationAreaValue.Id === 0 ? null : element.OperationAreaValue.Id),
                    "institutionName": element.Institution,
                    "dateAcquisition": element.DateAcquisition,
                    "yearCompletion": parseInt(element.YearCompletion)
                })
            });
        }

        return viewModelList;
    }
}